import { mapState } from 'vuex';
export default {
  props: {
    allRList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    partyCode: {
      default: ''
    },
    nickName: {
      default: ''
    },
    rtilCode: {
      default: ''
    },
    memberId: {
      default: ''
    },
    needAudio: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    liveInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    hadSelectRid: {
      type: String,
      default: ''
    },
    talkBack: {
      type: Boolean,
      default: false
    },
    useNewUi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSelectBox: false,
      sourceId: '',
      buttonItemInfo: {},
      loading: false,
      origin: '',
      tipsInfo: {
        title: 'pushParticipantSource.switchLive',
        content: '',
        cancel: 'pushParticipantSource.cancel',
        save: 'pushParticipantSource.confirm',
        show: false
      },
      selectPpId: '',
      scroll: {
        distance: 15,
        directive: '.liveCascader .list',
        useDocument: true,
        onScroll: this.loadNextPage
      }
    };
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    returnColorClass() {
      let _str = this.sourceId ? '' : 'grays';
      const isArray = this.sourceId instanceof Array;
      if (isArray) {
        this.sourceId.includes(this.liveInfo.type == 'T' ? this.liveInfo.livePeerId : this.liveInfo.peerId) && this.liveInfo.channel == this.partyCode ? _str += ' red-gradient' : '';
      } else {
        this.liveInfo.type == 'T' ? this.liveInfo.livePeerId : this.liveInfo.peerId == this.sourceId && this.liveInfo.channel == this.partyCode ? _str += ' red-gradient' : '';
      }
      return _str;
    }
  },
  watch: {
    liveInfo(val, old) {
      if (val.peerId && val.channel == this.partyCode && (old.peerId != val.peerId || old.channel != val.channel || !this.sourceId)) {
        if (this.$route.name == 'party' || this.$route.name == 'partyParticipate' || this.useNewUi) {
          // 先判断是和 cc live 还是和 pp live
          if ((!val.type || val.type == 'R') && val.peerId.includes('fffffffbb') || val.type == 'T' && val.livePeerId.includes('fffffffbb')) {
            var _this$allRList$;
            let ppReceiverId = '';
            ((_this$allRList$ = this.allRList[1]) === null || _this$allRList$ === void 0 ? void 0 : _this$allRList$.children) && this.allRList[1].children.forEach(item => {
              item.children.forEach(info => {
                if (info.value == val.peerId && (!val.type || val.type == 'R') || info.value == val.livePeerId && val.type == 'T') {
                  ppReceiverId = item.value;
                  this.selectPpId = item.productionId;
                }
              });
            });
            if (val.type == 'T') {
              this.sourceId = ['Producer', ppReceiverId, val.livePeerId];
            } else {
              this.sourceId = ['Producer', ppReceiverId, val.peerId];
            }
          } else {
            if (val.type == 'T') {
              this.sourceId = ['Receiver', val.livePeerId];
            } else {
              this.sourceId = ['Receiver', val.peerId];
            }
          }
        } else {
          if (val.type == 'T') {
            this.sourceId = val.livePeerId;
          } else {
            this.sourceId = val.peerId;
          }
        }
      }
    },
    sourceId(val) {
      this.$emit('callback', {
        type: 'changeSource',
        rtilCode: this.rtilCode,
        rid: val,
        id: val.id
      });
    },
    hadSelectRid: {
      immediate: true,
      handler: function (rid) {
        this.sourceId = rid;
      }
    }
  },
  created() {
    if (this.liveInfo.peerId && this.liveInfo.channel == this.partyCode) {
      this.sourceId = this.liveInfo.peerId;
    }
    // 注释的原因是因为判断条件不对导致切换选择的 R 会一直切换回正在 live 的 R
    // 代码是为了 coHost 抢占 t 加的但是后面逻辑写不下去了
    // Bus.$on('rtilLiveStatus', (v) => {
    //   if (v[this.rtilCode]) {
    //     // this.showSelectBox = true
    //     if (this.$route.name == 'party' || this.$route.name == 'partyParticipate' || this.useNewUi) {
    //       // 先判断是和 cc live 还是和 pp live
    //       if (v[this.rtilCode].peerId.includes('fffffffbb')) {
    //         let ppReceiverId = ''
    //         this.allRList[1].children.forEach(item => {
    //           item.children.forEach(info => {
    //             if (info.value == v[this.rtilCode].peerId) {
    //               ppReceiverId = item.value
    //             }
    //           })
    //         })
    //         this.sourceId = ['Producer', ppReceiverId, v[this.rtilCode].peerId]
    //       } else {
    //         this.sourceId = ['Receiver', v[this.rtilCode].peerId]
    //       }
    //     }
    //   }
    // })
  },

  methods: {
    loadNextPage() {
      this.$emit('callback', {
        type: 'loadNextPage',
        from: 'newSelect'
      });
    },
    beforeFilter() {
      return false;
    },
    dataFilter(node, val) {
      if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
        return true;
      }
    },
    showLabel(data) {
      if (data.label === 'Receiver') {
        return this.$t('arenaMode.receiver');
      } else if (data.label === 'Producer') {
        return this.$t('mainWindow.producer');
      } else {
        return data.label;
      }
    },
    changeR(val) {
      this.sourceId = val;
      this.allRList.forEach(item => {
        if (item.label === 'Producer') {
          this.State.ppConferenceRlist.forEach(info => {
            info.rids.forEach(rid => {
              if (rid == val) {
                this.selectPpId = info.id;
              }
            });
          });
        }
      });
    },
    changeNewR(val) {
      if (val.includes('Receiver')) {
        this.origin = 'cc';
      } else {
        this.origin = 'pp';
      }
      this.sourceId = val;
      this.allRList.forEach(item => {
        if (item.label === 'Producer') {
          this.State.ppRlist.forEach(info => {
            info.rids.forEach(rid => {
              if (rid == val[2]) {
                this.selectPpId = info.id;
              }
            });
          });
        }
      });
    },
    changeExpand(val) {
      if (val.length == 1) {
        this.$emit('callback', {
          type: 'initPageNum'
        });
      }
    },
    async startOrStop() {
      if (this.loading || !this.sourceId) return;
      this.loading = true;
      let ridVal;
      const _this = this;
      if (typeof _this.sourceId === 'string') {
        this.allRList.forEach(v => {
          if (v.options) {
            v.options.forEach(val => {
              if (val.peerId == this.sourceId) {
                if (v.label == 'Receiver') {
                  this.origin = 'cc';
                } else {
                  this.origin = 'pp';
                }
              }
            });
          }
        });
        ridVal = this.sourceId;
      } else {
        this.sourceId.includes('Receiver') ? _this.origin = 'cc' : _this.origin = 'pp';
        _this.origin === 'cc' ? ridVal = this.sourceId[1] : ridVal = this.sourceId[2];
      }
      if (_this.liveInfo.peerId == ridVal && (!_this.liveInfo.type || _this.liveInfo.type == 'R') || _this.liveInfo.livePeerId == ridVal && _this.liveInfo.type == 'T') {
        const parmas = {
          rid: ridVal,
          origin: this.origin,
          rtilCode: this.rtilCode,
          productionId: this.origin == 'pp' ? this.selectPpId : ''
        };
        if (!parmas.rid) return;
        this.axios.post('/partyline-backend/receiver/stopLive', parmas).then(res => {
          this.loading = false;
          if (res.data.errorCode === '0x0') {
            this.$emit('callback', {
              type: 'startlive',
              value: false
            });
            this.$message({
              type: 'success',
              message: this.$t('pushParticipantSource.stopLive')
            });
          }
        }).catch(() => {
          this.loading = false;
        });
      } else {
        const livePeerName = await this.checkRStatus(ridVal);
        if (livePeerName) {
          this.tipsInfo.content = '';
          this.tipsInfo.show = true;
          this.tipsInfo.content = `<div class="end">${this.$t('pushParticipantSource.content1')} ${livePeerName}, ${this.$t('pushParticipantSource.content2')}</div>`;
          return;
        }
        this.StatLive();
      }
    },
    StatLive() {
      let ridVal;
      if (typeof this.sourceId === 'string') {
        ridVal = this.sourceId;
      } else {
        this.origin === 'cc' ? ridVal = this.sourceId[1] : ridVal = this.sourceId[2];
      }
      const params = {
        rid: ridVal,
        origin: this.origin,
        sourceId: '',
        sourceType: '',
        partyCode: this.partyCode,
        rtilCode: this.rtilCode,
        productionId: this.origin == 'pp' ? this.selectPpId : '',
        memberId: '',
        sourceName: this.nickName ? `PL_${this.nickName}_${this.rtilCode}_${this.partyCode}` : `${this.rtilCode}_${this.partyCode}`,
        needAudio: true // shareScreen时，needAudio为false，其他为true
      };
      //! this.memberId.includes('_sharescreen')加这个是为了因为多分享而导致的无法和 sharescreen live 的问题
      if ((this.memberId.length == 16 || this.memberId.length == 15) && !this.memberId.includes('_sharescreen')) {
        params.sourceId = this.memberId;
        params.sourceType = 'anywhere';
      } else {
        params.sourceId = this.rtilCode;
        params.sourceType = 'rtil';
        params.memberId = this.memberId;
      }
      if (!params.sourceId || !ridVal) return;
      this.axios.post('/partyline-backend/receiver/startLive', params).then(res => {
        this.loading = false;
        if (res.data.errorInfo === 'OK') {
          this.$emit('callback', {
            type: 'startlive',
            rtilCode: this.rtilCode,
            rid: ridVal,
            value: true
          });
          this.$message({
            type: 'success',
            message: this.$t('pushParticipantSource.success')
          });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 没有直接用startlive是怕以后有需求会需要修改一些东西
    switchLive() {
      this.StatLive();
    },
    cancelSwitch() {
      this.loading = false;
    },
    checkRStatus(rid) {
      if (!rid) return;
      return new Promise((resolve, reject) => {
        this.axios.get('/partyline-backend/receiver/getDevice', {
          params: {
            peerId: rid
          }
        }).then(res => {
          if (!res) return;
          const result = res.data;
          if (result.errorCode === '0x0') {
            let _str = '';
            if (result.result.status === '2') {
              result.result.livePeerName ? _str = result.result.livePeerName : _str = result.result.livePeerId;
            }
            resolve(_str);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    getSourceList(type, val) {
      if (type == 'getReceiverList') {
        this.$emit('callback', {
          type: 'getReceiverList',
          filter: false
        });
      } else if (type == 'filter') {
        this.$emit('callback', {
          type: 'getReceiverList',
          val: val,
          filter: true
        });
      }
    },
    iptChange(el) {
      const val = el.target.value;
      this.$emit('callback', {
        type: 'getReceiverList',
        filter: true,
        from: 'newSelect',
        val: val
      });
    },
    getNewSourceList(type, val) {
      if (type == 'getReceiverList') {
        this.$emit('callback', {
          type: 'getReceiverList',
          filter: false,
          from: 'newSelect',
          val
        });
      }
    }
  }
};